import React, { useEffect, useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import SecurityModal from 'pages/Events/Views/Common/Modals/SecurityModal'
import { classesEventStore } from 'state/classes/classesStore'

const Security: React.FC = () => {
  const [openSecurityModal, setOpenSecurityModal] = useState<boolean>(false)
  const { riskLevel, setRiskLevel, classesData } = classesEventStore(store => ({
    riskLevel: store.riskLevel,
    setRiskLevel: store.setRiskLevel,
    classesData: store.classesData,
  }))

  useEffect(() => {
    setRiskLevel(classesData.riskLevel)
  }, [])

  return (
    <>
      <div onClick={() => setOpenSecurityModal(true)}>
        <IconsTextNavigation
          iconName="ShieldCheck"
          heading="Security"
          isCompleted={riskLevel}
        />
      </div>
      {openSecurityModal && (
        <SecurityModal
          openModal={openSecurityModal}
          closeModal={setOpenSecurityModal}
          riskLevel={riskLevel}
          setRiskLevel={setRiskLevel}
        />
      )}
    </>
  )
}

export default Security
